import { RouteRecordRaw } from 'vue-router';

const MatchesOverview = () => import('@/modules/matching/pages/MatchingOverview.vue');

// Matching routes
const CandidateMatchingDetail = () => import('@/modules/candidates/components/candidate-details/CandidateDetails.vue');
const PositionMatchingDetail = () => import('@/modules/positions/components/position-details/PositionDetails.vue');
const CustomerMatchingDetail = () => import('@/modules/customers/components/customer-details/CustomerDetails.vue');

const MATCHING_ROUTES: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'MatchingOverview',
      component: MatchesOverview,
      children: [
         {
            path: 'candidate/:id',
            name: 'CandidateMatchingDetail',
            component: CandidateMatchingDetail,
            meta: {
               targetType: ['candidate'],
            },
         },
         {
            path: 'position/:id',
            name: 'PositionMatchingDetail',
            component: PositionMatchingDetail,
            meta: {
               targetType: ['position', 'advertsdata-position'],
            },
         },
         {
            path: 'customer/:id',
            name: 'CustomerMatchingDetail',
            component: CustomerMatchingDetail,
            meta: {
               targetType: ['customer'],
            },
         },
      ],
   },
];

export { MATCHING_ROUTES };
